import { Annual } from 'components/resort/HistoricalSnowfall/Annual';
import { useCallback, useEffect, useState } from 'react';
import { HistoricalSnowfallType, ISnowfallItem } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Monthly } from 'components/resort/HistoricalSnowfall/Monthly';
import { useAnalytics } from 'util/analytics';
import styles from './styles.module.scss';

export const HistoricalSnowfall = (
  {
    snowfallInfoMonthly,
    snowfallInfoAnnual,
    resortName,
  }: {
    snowfallInfoMonthly: Array<ISnowfallItem>,
    snowfallInfoAnnual: Array<ISnowfallItem>
    resortName: string
  },
) => {
  const getAvailableSnowfallTab = () => {
    if (snowfallInfoMonthly.length) {
      return HistoricalSnowfallType.monthly;
    } if (snowfallInfoAnnual.length) {
      return HistoricalSnowfallType.annual;
    }
    return '' as HistoricalSnowfallType;
  };

  const [activeTab, setActiveTab] = useState(getAvailableSnowfallTab);
  const { t } = useOTSTranslation('common');

  useEffect(() => {
    setActiveTab(getAvailableSnowfallTab());
  }, [snowfallInfoMonthly, snowfallInfoAnnual]);

  const a = useAnalytics();
  const setMonthly = useCallback(() => {
    setActiveTab(HistoricalSnowfallType.monthly);
  }, [a, setActiveTab]);

  const setAnnual = useCallback(() => {
    a.viewContent({
      content: 'Annual Snowfall',
    });
    setActiveTab(HistoricalSnowfallType.annual);
  }, [a, setActiveTab]);

  const title = activeTab === HistoricalSnowfallType.monthly
    ? t('resort.historicalSnowfall.monthTabTitle' as any, { resort: resortName })
    : t('resort.historicalSnowfall.annualTabTitle' as any, { resort: resortName });

  return (
    <div className={styles.wrap}>
      <header className={styles.headerSnowfall}>
        <h2 className={styles.title}>{title}</h2>
        {
          !!(snowfallInfoMonthly.length) && !!(snowfallInfoAnnual.length)
          && (
            <div className={styles.tabs}>
              <button
                type="button"
                className={activeTab === HistoricalSnowfallType.monthly ? styles.active : ''}
                onClick={setMonthly}
              >
                {t('resort.historicalSnowfall.monthly')}
              </button>
              /
              <button
                type="button"
                className={activeTab === HistoricalSnowfallType.annual ? styles.active : ''}
                onClick={setAnnual}
              >
                {t('resort.historicalSnowfall.annual')}
              </button>
            </div>
          )
        }
      </header>
      <Monthly infoMonthly={snowfallInfoMonthly} visible={activeTab === HistoricalSnowfallType.monthly} />
      <Annual infoAnnual={snowfallInfoAnnual} visible={activeTab === HistoricalSnowfallType.annual} />
    </div>
  );
};
